module.exports = __webpack_public_path__ + "static/media/team-alex.485c964d.jpg";